module.exports = __webpack_public_path__ + "img/44250366000194.caa0ab6c.png";